import { routerModel } from "@/router/router.model";
import { Prop, Vue } from "vue-property-decorator";
import { appLanguageSwitcherModel } from "../app-language-switcher/app-language-switcher.model";

export interface LinkAttributes {
    link: string;
    page: string; // numeric
    color: string;
    title: string;
}

export class AppLinkComponent extends Vue {
    @Prop({ required: true }) link!: LinkAttributes;

    get externalLink() {
        if (this.internalLink) {
            return undefined;
        }

        return this.link.link;
    }

    get internalLink() {
        if (this.link.link) {
            if (
                routerModel.router
                    .getRoutes()
                    .some((route) => route.path === this.link.link)
            ) {
                return this.link.link;
            }

            return undefined;
        }

        return { name: this.pageName };
    }

    get pageName(): string {
        const id = this.link.page;

        return id &&
            appLanguageSwitcherModel.lang.value in routerModel.routes.value &&
            id in routerModel.routes.value[appLanguageSwitcherModel.lang.value]
            ? routerModel.routes.value[appLanguageSwitcherModel.lang.value][id].name
            : "homepage";
    }
}
